<template>
  <div>
    <component style="display: none" :is="show_document"></component>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <strong>حواله فروش تامین کننده</strong>
              </CCol>
              <CCol style="text-align: end;">
                <CButton
                    class="mr-1"
                    size="sm"
                    @click="print_with_header('print_report_buy','print_report_header','print_report_footer')"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>


              </CCol>

            </CRow>

          </CCardHeader>
          <div v-show="false">
            <div id="print_report_header" class="border-dark">
              <CCardHeader>
                <CRow style="border: 1px solid #000">

                  <CCol sm="4" md="4" style="text-align: right">
                    <h2>{{ get_date(new Date()) }}</h2>
                  </CCol>
                  <CCol sm="4" md="4" style="text-align: center">
                    <h2>لیست فاکتور های خرید شده</h2>

                  </CCol>
                  <CCol sm="4" md="4" style="text-align: left">
                    <CImg :src="get_logo()" width="100px" height="50px"/>

                  </CCol>
                </CRow>

              </CCardHeader>

            </div>
            <div id="print_report_footer" class="border-dark">
              <CCardHeader>
                <CRow style="border: 1px solid #000">
                  <CCol sm="4" md="4" style="text-align: start">
                    <h2>{{$t('docCreator')}} : {{ get_user_name() }}</h2>
                  </CCol>
                  <CCol sm="4" md="4" style="text-align: center">
                    <h2 id="pageFooter" class="pageFooter"></h2>
                  </CCol>
                  <CCol sm="4" md="4" style="text-align: end">
                    <h2>

                    </h2>
                  </CCol>
                </CRow>

              </CCardHeader>

            </div>

          </div>

          <CCardBody id="print_report_buy">
            <CRow>
              <CCol col="3">
                <date-picker

                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>

            </CRow>
            <CDataTable
                :items="items_sell"
                :fields="fields"
                column-filter
                @row-clicked="table_row_clicked"
                :items-per-page="20"
                hover
                sorter
                border
                striped
                :sorter-value="{column:'recId',asc:false}"
                pagination
            >
              <template #row="{item}">
                <td style="text-align: center">
                  <p>{{ item.row_id + 1 }}</p>
                </td>
              </template>
              <template #createdAt="{item}">
                <td>
                  <p>{{ get_date(item.createdAt) }}</p>
                </td>
              </template>

              <template #totalPrice="{item}">
                <td>
                  <p>{{ get_currency(item.totalPrice) }}</p>
                </td>
              </template>
              <template #payStatus="{item}">
                <td>
                  <p v-if="item.payStatus==1" class="text-success">پرداخت شده</p>
                  <p v-if="item.payStatus==0" class="text-danger">پرداخت نشده</p>
                </td>
              </template>
              <template #deliveryStatus="{item}">
                <td>
                  <p v-if="item.deliveryStatus==2" >تحویل مشتری</p>
                  <p v-if="item.deliveryStatus==1">در دست راننده</p>
                  <p v-if="item.deliveryStatus==0">ثبت شده</p>
                </td>
              </template>
              <template #caption>
                <td class="bg-dark"></td>
                <td class="bg-dark"></td>
                <td class="bg-dark">جمع کل</td>
                <td class="bg-dark">{{ get_currency(total_item_price()) }}</td>

              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
var items_data = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',


      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_driver: 0,
      driver_items: [],
      items_sell: [],
      table_clicks_timer: '',
      table_clicks: 0,

      fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'createdAt', label: this.$t('tables.date'), _style: 'width:15%'},

        {key: 'id', label: this.$t('tables.number'), _style: 'width:2%'},
        // {key: 'totalPrice', label: this.$t('customer'), _style: 'width:10%'},
        // {key: 'deliveryCost', label: 'هزینه پیک', _style: 'width:10%'},
        // {key: 'deliveryStatus', label: this.$t('tables.status'), _style: 'width:10%'},
        // {key: 'payStatus', label: "وضعیت پرداخت", _style: 'width:10%'},
        // {key: 'driverName', label: this.$t('tables.driver'), _style: 'width:10%'},

        {key: 'totalPrice', label: this.$t('tables.totalAmount'), _style: 'width:10%'},
      ],

      status_form: 0,

    }
  }, mounted() {

    this.start_date = this.get_day_before_today_in_day(1);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];
    this.get_all_data();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.person_id': function () {
      this.get_all_data();
    },
    'start_date': function () {
      this.get_all_data();
    },
    'end_date': function () {
      this.get_driver_lists();
    },
    'selected_driver': function () {
      this.get_all_data();

    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.goShowDocument(item)

      }

    },
    total_item_price(){
      var total_price = 0;
      this.items_sell.forEach((val)=>{
        total_price+=val.totalPrice;
      })
      return total_price;
    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/orders/show-supplier-doc/' + item.masterId});
    },
    get_all_data() {
      this.get_lists_sell();

    },

    get_lists_sell() {

      var self = this;


      const formData = new FormData();
      var url = "GetSupplierReferredBySuppId";
      // formData.append("SupplierId", localStorage.getItem('user_id'));
      // formData.append("SupplierId", 11);
      // formData.append("SupplierId", localStorage.getItem('user_id'));
      formData.append("SupplierId", this.$route.params.user_id);
      axios.post(url, formData, {}).then(function (response) {
        var content_data = response.data;
        if (content_data.statusCode == 0) {
          self.items_sell = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },
    get_driver_lists() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetDistributorUsers', formData, {}).then(function (response) {

        var content_data = response.data;
        self.driver_items = [{label: 'انتخاب کنید', value: 0}]
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.driver_items = self.sort_array(self.driver_items, content_data.data, 'personId', 'personName');
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },


  },

}

</script>
